<p>
  <a routerLink="/stock/WarwickFarm" routerLinkActive='active'>Sydney</a><br/>
  <a routerLink="/stock/Campbellfield" routerLinkActive='active'>Melbourne</a><br/>
  <a routerLink="/stock/Crestmead" routerLinkActive='active'>Brisbane</a><br/>
</p>
